import { PayloadAction } from '@reduxjs/toolkit';
import { ChannelSettingsReducerCreator } from '../types';

const setShowSelectIntegrationModalReducer = (create: ChannelSettingsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<boolean>) => {
    state.showSelectIntegrationModal = action.payload;
  });
};

export default setShowSelectIntegrationModalReducer;
